export default {
    namespaced: true,

    state: {
        game: {
            currentGame: null,

            games: [
                {
                    gameID: 'LottoBricks',
                    name: 'Lotto - Bricks',
                    description: 'Vang 5x € 900 en maak kans op € 4.500!',
                    shareImage: './static/game/LottoBricks/shareimage.png',
                    iframeSrc: 'https://lotto-bricks.accept2.mrynk.net/'
                },
                {
                    gameID: 'LottoStop45',
                    name: 'Lotto - Stop 45!',
                    description: 'Stop de Lotto bal op 45 en maak kans op € 4.500!',
                    shareImage: './static/game/LottoStop/shareimage.png',
                    iframeSrc: 'https://lotto-stop45.accept3.mrynk.net/'
                },
                {
                    gameID: 'LottoEropuit',
                    name: 'Lotto - Eropuit!',
                    description: 'Beantwoord de vragen en maak kans op geweldige prijzen!',
                    shareImage: './static/game/LottoEropuit/shareimage.jpg',
                    iframeSrc: 'https://lotto-eropuit.accept.mrynk.net/'
                },
                {
                    gameID: 'Gelukszomer',
                    name: 'Staatsloterij - Gelukszomer',
                    description: 'Speel het Staatsloterij VakantieVeilingen spel en maak kans op één van de 300 1/5 loten en een iPhone Xr!',
                    shareImage: './static/game/STLGelukszomer/shareimage.png',
                    iframeSrc: 'http://gelukszomer.accept.mrynk.net/'
                }
            ]
        }
    },

    getters: {
        currentGame: state => state.game.currentGame,
        games: state => state.game.games,
        find: ( state ) => ( gameID ) =>
        {
            return state.game.games.filter( game =>
                {
                    return gameID === game.gameID;
                });
        }
    },

    mutations: {
        setCurrentGame: ( state, payload ) =>
        {
            state.game.currentGame = payload;
        }
    },

    actions: {
        setCurrentGame: ( context, payload ) =>
        {
            context.commit( 'setCurrentGame', payload );
        }
    }
};
